import { Button, Modal } from "antd";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import ROLES from "../config/roles";
import { COLORS } from "../config/theme";
import AddAppleWalletButton from "./AddAppleWalletButton";
import AddGoogleWalletButton from "./AddGoogleWalletButton";

const { primaryDark, white } = COLORS;

const AddWalletButton = ({ vCard = { _id: null }, style = {}, ...props }) => {
  const [showWalletModal, setShowWalletModal] = useState(false);
  const [showPremiumPage, setShowPremiumPage] = useState(false);
  const history = useHistory();

  const {
    user: { role },
  } = useSelector((state) => state.auth);
  const { subscribedPlan } = useSelector((state) => state.membership);
  const hasPremium = subscribedPlan?.paymentStatus === "SUCCESS";

  const onHandleWalletClick = (e) => {
    if (
      [
        ROLES.ADMIN,
        ROLES.SUB_ADMIN,
        ROLES.EDITOR_ADMIN,
        ROLES.ACTING_ADMIN,
      ].includes(role) &&
      !hasPremium
    ) {
      setShowPremiumPage(true);
      return;
    }

    setShowWalletModal(true);
  };

  const isDisabled = ![
    ROLES.ADMIN,
    ROLES.SUB_ADMIN,
    ROLES.EDITOR_ADMIN,
    ROLES.ACTING_ADMIN,
  ].includes(role);

  return (
    <>
      <Button
        shape="round"
        type="primary"
        disabled={isDisabled}
        style={{
          borderColor: isDisabled ? "lightgray" : primaryDark,
          background: isDisabled ? "lightgray" : primaryDark,
          color: white,
          ...style,
        }}
        onClick={onHandleWalletClick}
        htmlType="button"
        {...props}
      >
        Add to Wallet
      </Button>
      <Modal
        visible={showWalletModal}
        destroyOnClose={true}
        title="I would like to add my card to"
        footer={null}
        maskClosable={false}
        onCancel={() => {
          setShowWalletModal(false);
        }}
        width={450}
      >
        <div style={{ textAlign: "center" }}>
          <div>
            <AddAppleWalletButton
              vCard={vCard}
              secondaryColor="white"
              backgroundColor="black"
            ></AddAppleWalletButton>
          </div>
          <div>
            <AddGoogleWalletButton
              vCard={vCard}
              secondaryColor="white"
              backgroundColor="black"
            ></AddGoogleWalletButton>
          </div>
        </div>
      </Modal>
      <Modal
        visible={showPremiumPage}
        destroyOnClose={true}
        title=""
        footer={null}
        maskClosable={false}
        onCancel={() => {
          setShowPremiumPage(false);
        }}
        width={450}
      >
        <div style={{ textAlign: "", padding: "1rem 0" }}>
          {[ROLES.ADMIN, ROLES.ACTING_ADMIN].includes(role) ? (
            <h2>Upgrade your plan to get this feature, try for free</h2>
          ) : (
            <h2>Please ask Admin to upgrade your plan to get this feature</h2>
          )}
        </div>
        {[ROLES.ADMIN, ROLES.ACTING_ADMIN].includes(role) ? (
          <div style={{ textAlign: "right" }}>
            <Button
              shape="round"
              style={{
                marginTop: "1rem",
                borderColor: "white",
                color: "white",
                backgroundColor: "black",
                borderWidth: 0,
                boxShadow: "3px 3px 3px 3px #88888a3a",
              }}
              onClick={(e) => history.push("/app/subscriptions-and-plans")}
            >
              Learn more
            </Button>
          </div>
        ) : (
          <div style={{ textAlign: "right" }}>
            <Button
              shape="round"
              style={{
                marginTop: "1rem",
                borderColor: "white",
                color: "white",
                backgroundColor: "black",
                borderWidth: 0,
                boxShadow: "3px 3px 3px 3px #88888a3a",
              }}
              onClick={(e) => setShowPremiumPage(false)}
            >
              OK
            </Button>
          </div>
        )}
      </Modal>
    </>
  );
};

export default AddWalletButton;
